
import { defineComponent, getCurrentInstance, onMounted, ref, watch, nextTick, onActivated, onDeactivated } from 'vue';
import cookies from 'js-cookie';
import { header, extractTitleFromMetaInfo, getDefaultTitle } from '@/common/seo';
import { setCommonParamsCookiesInServer } from '@/common/common-params';
import { immediateSendLog, sendLog } from '@/common/radar';
import { commonPvParams, FeedType } from '@/common/utils';
import { RequestSource } from '@/api/base';
import { SEOApi } from '~/api/seo';
import { FeedApi } from '@/api/feed';
import { CrawlersApiRequest } from '@/common/crawlers';

import PwaVideoDetailShare from '@/pages/video/_photoId.vue';

export default defineComponent({
    components: {
        PwaVideoDetailShare,
    },
    setup(props, ctx) {
        const { proxy } = getCurrentInstance() as any;
        const videoList = ref(proxy.$store.state.videoList || []);
        const muted = ref(false);
        const sendPv = () => {
            const params = commonPvParams({ defaultPageSource: 'pc-video-detail-search' });
            // 获取启动config
            const country = proxy.$store.state.startup.countryInfo;
            const user_id = cookies.get('user_id');
            immediateSendLog({
                type: 'pv',
                name: 'PWA_DISCOVER_SEARCH',
                value: {
                    country,
                    user_id,
                    ...params,
                },
            });
        };
        onMounted(async () => {
            sendPv();
            proxy.$bus.emit('video-muted', proxy.$store.state.globalMuted);
        });
        return {
            muted,
            videoList,
        };
    },
    async asyncData(ctx: any) {
        let photoList: Record<string, any>[] = [];
        let seoData = [];
        let metaInfoData = [];
        let title = getDefaultTitle(ctx);
        const showFeed = false;
        if ((process as any).server) {
            setCommonParamsCookiesInServer({
                bucket: ctx.store.state.startup.bucket,
                host: ctx.req.headers.host,
                ctx,
                countryInfo: ctx.store.state.startup.countryInfo,
            });
            try {
                const { photoId } = ctx.route?.query;
                const pathName = ctx?.route?.path;
                const realPhotoId = pathName?.match(/\/video\/(\d+)/)?.[1] || photoId;
                const url = `https://${ctx?.req?.headers?.host}${ctx?.route?.path}` || '';
                const photoRes = await CrawlersApiRequest.getDiscoverSearchFeedList({
                    count: 4,
                    mobile: true,
                    requestSource: RequestSource.REQUEST_SOURCE_PWA_DISCOVER_SEARCH,
                    url,
                    photoIdStr: realPhotoId || '',
                    onlyTitle: false,
                    needTdk: true,
                    needLdJson: true,
                    crawler: ctx?.$store?.state?.startup?.crawler,
                });
                if (photoRes?.result === 1) {
                    photoList = photoRes.feeds || [];
                    metaInfoData = photoRes.tdk || [];
                    ctx.store.commit('setVideoList', photoList);
                    ctx.store.commit('setMetaInfoData', metaInfoData);
                    seoData = photoRes?.ldJson || [];
                    metaInfoData = photoRes?.tdk || [];
                    title = extractTitleFromMetaInfo({ ctx, metaInfoData });
                }
            } catch (error) {
                console.log(error);
            }
        }
        ctx.store.commit('setSource', 'search');
        return {
            photoList,
            showFeed,
            seoData,
            metaInfoData,
            title,
        };
    },
    head() {
        const head = header(this);
        return {
            ...head,
        };
    },
});
